import { render, staticRenderFns } from "./OtherSolutionsList.vue?vue&type=template&id=6032e545&scoped=true"
import script from "./OtherSolutionsList.vue?vue&type=script&lang=js"
export * from "./OtherSolutionsList.vue?vue&type=script&lang=js"
import style0 from "./OtherSolutionsList.vue?vue&type=style&index=0&id=6032e545&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6032e545",
  null
  
)

export default component.exports